import axios from "axios";
import {
  getClientIdentityHeaders,
  withClientIdentity,
} from "../utils/clientIdentity";
import { withApiError } from "../utils/apiError";

const BASE_URL = process.env.REACT_APP_BASE_BACKEND_API_URL;

export const loginUser = async (values) => {
  const response = await axios.post(
    `${BASE_URL}api/v1/user/login`,
    withClientIdentity(values),
    {
      headers: {
        ...getClientIdentityHeaders(),
        "Content-Type": "application/json",
      },
    }
  );

  return withApiError(response.data);
};

export const verifyLoginOtp = async (email, otp) => {
  const response = await axios.post(
    `${BASE_URL}api/v1/user/verify-login-otp`,
    { email, otp },
    {
      headers: {
        "X-App-Type": "web",
        "Content-Type": "application/json",
      },
    },
  );

  return withApiError(response.data);
};

export const resendLoginOtp = async (email) => {
  const response = await axios.post(
    `${BASE_URL}api/v1/user/resend-login-otp`,
    { email },
    {
      headers: {
        "X-App-Type": "web",
        "Content-Type": "application/json",
      },
    },
  );

  return withApiError(response.data);
};

export const getUserPermissions = async (accessToken) => {
  const response = await axios.get(`${BASE_URL}api/v1/user/permissions`, {
    headers: {
      "X-App-Type": "WEB",
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return withApiError(response.data);
};
export const storeFcmToken = async (token, accessToken) => {
  const response = await axios.post(
    `${BASE_URL}api/v1/notification/store-fcm-token`,
    { token },
    {
      headers: {
        "X-App-Type": "WEB",
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  return withApiError(response.data);
};

export const forgotPassword = async (email) => {
  const response = await axios.post(
    `${BASE_URL}api/v1/user/forgot-password`,
    {},
    {
      params: { email },
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return withApiError(response.data);
};

export const checkOtp = async (otp, email) => {
  const response = await axios.post(
    `${BASE_URL}api/v1/user/check-otp`,
    { otp, email },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return withApiError(response.data);
};

export const resetPassword = async (email, password) => {
  const response = await axios.post(
    `${BASE_URL}api/v1/user/new-password`,
    { email, password },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return withApiError(response.data);
};
